import { api } from '../api/client';
import { PAGES } from '../api/endpoints';
import { buildQuery } from '../api/helpers';

export const pagesService = {
  feed: ({ limit = 20, cursor, category, q } = {}) =>
    api.get(`/pages/feed${buildQuery({ limit, cursor, category, q })}`),
  article: (id) => api.get(PAGES.ARTICLE(id)),
  alerts: (params = {}) =>
    api.get(`/pages/alerts${buildQuery(params)}`),
  profile: () => api.get(PAGES.PROFILE),
  adminDashboard: () => api.get(PAGES.ADMIN_DASHBOARD),
  adminContent: (status, q) => api.get(PAGES.ADMIN_CONTENT(status, q)),
  adminSources: () => api.get(PAGES.ADMIN_SOURCES),
  adminAlerts: (params = {}) =>
    api.get(`/pages/admin/alerts${buildQuery(params)}`),
  adminAnalytics: (params = {}) =>
    api.get(`/pages/admin/analytics${buildQuery(params)}`),
};
